import {
  WholeAction,
  CategorizedActions,
} from "@pslifestyle/common/src/types/planTypes";

export const categorizeActions = (
  actions: WholeAction[],
): CategorizedActions => {
  const categorized: CategorizedActions = {
    housing: [],
    transport: [],
    food: [],
    purchases: [],
  };

  actions.forEach((action) => {
    switch (action.category.toLowerCase()) {
      case "transport":
        categorized.transport.push(action);
        break;
      case "food":
        categorized.food.push(action);
        break;
      case "housing":
        categorized.housing.push(action);
        break;
      case "purchases":
        categorized.purchases.push(action);
        break;
      default:
        break;
    }
  });

  return categorized;
};

export const sortActionsByImpact = (actions: WholeAction[]): WholeAction[] =>
  actions.sort((a, b) => b.calculatedImpact - a.calculatedImpact);

export const sortActionsBySortKey = (actions: WholeAction[]): WholeAction[] =>
  actions.sort((a, b) => a.sortKey.localeCompare(b.sortKey));
